
export const API_URL = process.env.REACT_APP_API_URL;
export const API_CONSULTA_URL = process.env.REACT_APP_API_CONSULTA_URL;
export const IS_HOMOLOG = process.env.REACT_APP_HOMOLOG ?? "0";
export const ID_TOKEN = 'fd-painel_token__';
export const TOKEN_DECODED = 'fd-painel_token_decoded__';
export const ID_LAST_ROUTE = 'fd-painel_lastroute__';
export const BUCKET_STORAGE = 'storage-whitelabel';
export const HOST = 'fd-host__';
export const THEME = 'fd-theme__';
export const BUCKET_ROBOT_FILES_QUEUE = 'robot-files-queue';
export const VERSION = '1.49.6';
export const MIN_VALUE_ADD_FUNDS = 5;
export const CREDIT_CARD_FIXED_FEE = 0.5;
export const CREDIT_CARD_PERCENTUAL_FEE = 3;
export const PIX_FIXED_FEE = 2;
export const PIX_PERCENTUAL_FEE = 0;
export const BOLETO_FIXED_FEE = 2;
export const BOLETO_PERCENTUAL_FEE = 0;
export const TIME_REFRESH_CHAT = 10000;
